export function setDocumentDirectionPerLocale(locale) {
    document.dir = locale === "he" ? "rtl" : "ltr"
    if(locale === "en")
        document.body.classList.add(locale)
    else document.body.classList.remove("en")
}
export function setDocumentLang(lang) {
    document.documentElement.lang = lang
}

export function setDocumentTitle(newTitle) {
    document.title = newTitle
}